import React from 'react';
import LoginPage from '../components/LoginPage';

const Login: React.FC = () => {
  return <LoginPage />;
};

export default Login;